/**
 * Link element to be used on AnchorLinks component
 *
 * @module views/components/AnchorLink
 * @memberof -Common
 */
import './AnchorLink.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Icon from '@ulta/core/components/Icon/Icon';
import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';
import Text from '@ulta/core/components/Text/Text';
import UltaAsset from '@ulta/core/components/UltaAsset/UltaAsset';
import { spreadProps } from '@ulta/core/utils/dom/dom';

/**
 * Represents a AnchorLink component
 *
 * @method
 * @param { AnchorLinkProps} props - React properties passed from composition
 * @returns AnchorLink
 */
export const AnchorLink = function( props ){
  const { image, action, icon } = props;

  if( !action ){
    return null;
  }

  return (
    <div className='AnchorLink'>
      <Link_Huge
        action={ action }
      >
        {
          image &&
          <div className='AnchorLink__image'>
            <UltaAsset
              aspectRatio='1:1'
              { ...spreadProps( { ...image } ) }
            />
          </div>
        }
        {
          action?.label &&
          <div className='AnchorLink__label'>
            <Text
              textStyle='body-2'
              htmlTag='span'
              textAlign='center'
            >
              { action.label }
            </Text>
            {
              icon &&
              <Icon
                size='s'
                name={ icon }
                aria-hidden={ true }
                className='AnchorLink__icon'
              />
            }
          </div>
        }

      </Link_Huge>
    </div>
  );
};

/**
 * Property type definitions
 * @typedef AnchorLinkProps
 * @type {object}
 * @property {object} image - Sets image properties
 * @property {object} action - Sets url and label
 * @property {string} icon - Sets icon for label
 */
export const propTypes =  {
  image: PropTypes.object,
  action: PropTypes.object.isRequired,
  icon: PropTypes.string
};

AnchorLink.propTypes = propTypes;

export default AnchorLink;
